import {FieldDataType, XyiconFeature} from "../../../../generated/api/base";
import {FieldDataTypes} from "../FieldDataTypes";
import type {User} from "../../User";
import {PeopleSingleChoiceInputV5} from "../../../../ui/5.0/details/datatypes/PeopleSingleChoiceInputV5";
import {PeopleSingleChoiceInput} from "../../../../ui/widgets/input/people/PeopleSingleChoiceInput";
import {PeopleFieldSettings} from "../../../../ui/modules/settings/modules/field/datatypes/PeopleFieldSettings";
import {PeopleFieldSettingsV5} from "../../../../ui/5.0/details/PeopleFieldSettingsV5";
import type {AppActions} from "../../../state/AppActions";
import {StringUtils} from "../../../../utils/data/string/StringUtils";
import {FilterOperator} from "../../filter/operator/FilterOperator";

const parseValue = (userId: string, actions: AppActions) => {
	if (userId && actions) {
		return actions.getFeatureItemById<User>(userId, XyiconFeature.User);
	}

	return userId ?? null;
};

export const renderUserValue = (userMaybe?: User) => (userMaybe?.fullName ? `${userMaybe.fullName} (${userMaybe.email})` : (userMaybe?.email ?? ""));
export const compareUsers = (a: User, b: User) => StringUtils.sortIgnoreCase(a.fullName ?? a.email, b.fullName ?? b.email);

export const extractEmailFromRenderedUser = (renderedUser: string) => {
	if (!renderedUser.endsWith(")")) {
		return renderedUser;
	}

	const openingParenthesisIndex = renderedUser.lastIndexOf("(");

	return openingParenthesisIndex >= 0 && openingParenthesisIndex < renderedUser.length - 2
		? renderedUser.slice(openingParenthesisIndex + 1, -1)
		: renderedUser;
};

export function configurePeopleSingle() {
	FieldDataTypes.configure({
		id: FieldDataType.PeopleSingleChoiceList,
		title: "People",
		converter: parseValue,
		formatter: renderUserValue,
		input: PeopleSingleChoiceInput,
		inputV5: PeopleSingleChoiceInputV5,
		operatorsArray: [
			FilterOperator.IS_EQUAL_TO_STR,
			FilterOperator.CONTAINS,
			FilterOperator.DOES_NOT_CONTAIN,
			FilterOperator.IS_BLANK,
			FilterOperator.IS_NOT_BLANK,
			FilterOperator.IS_ANY_OF,
			FilterOperator.IS_NOT_ANY_OF,
		],
		settings: PeopleFieldSettings,
		settingsV5: PeopleFieldSettingsV5,
	});
}
